import React, { useState } from "react";
import Button from "sushiweb/Button";

import Permission from "../../../components/Common/Permission";
import FilterButton from "../../../components/Common/FilterButton";
import BannersList from "../../../components/DriverBanner/BannersList";

import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import {
  BottomSectionModal,
  FlexContainer,
  Heading,
} from "../../../constants/assets/containers";
import NoFooterModal from "../../../components/Common/NoFooterModal";
import { useHistory } from "react-router-dom";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../../components/Common/PaginatedReactDropdown";
import Pagination from "../../../components/Common/Pagination/Pagination";
import usePagination from "../../../hooks/usePagination";
import useApi from "../../../hooks/useApi";
import DriverBannerApis from "../../../services/api/DriverBanner";

const filterOptions = [
  // { label: "Banner Name", value: "name" },
  {
    label: "Banner ID",
    value: "_id",
  },
];

const BannerList = () => {
  const { page, perPage, handlePagination } = usePagination();
  const [formError, setFormError] = useState("");
  const allActions = MenuActionsMappings[MenuNames.DRIVER_BANNER];
  const [modalState, setModalState] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);

  const history = useHistory();
  const [filterInputState, setFilterInputState] = useState({
    type: "",
    // name: "",
    _id: "",
  });

  const { data, isLoading, error, refetch } = useApi({
    queryKey: [page, perPage, appliedFilters],
    queryFn: () =>
      DriverBannerApis.fetchBannerList({
        filters: appliedFilters,
        page_request: {
          page,
          page_size: perPage,
        },
      }),
    initialData: {
      page_response: {
        previous_page: -1,
        next_page: -1,
        items_count: 10,
      },
      banner_details: [],
    },
  });

  const handleFilterModalClose = () => {
    setModalState(false);
    setFormError("");
  };

  const handleClearFilters = () => {
    setAppliedFilters([]);
    handleFilterModalClose();
  };

  const handleFiltersApply = (e) => {
    let appliedFilters = {};
    if (filterInputState.type == "") {
      setFormError("Please select filter type");
      return;
    }
    // if (filterInputState.type == "name") {
    //   if (filterInputState.name == "") {
    //     setFormError("Please select campaign name");
    //     return;
    //   }
    //   appliedFilters["value"] = filterInputState.name;
    //   appliedFilters["type"] = "name";
    // }
    if (filterInputState.type == "name") {
      if (filterInputState.name == "") {
        setFormError("Please select campaign name");
        return;
      }
      appliedFilters["name"] = filterInputState.name;
      appliedFilters["type"] = "name";
    }
    if (filterInputState.type == "_id") {
      if (filterInputState._id == "") {
        setFormError("Please select an ID");
        return;
      }
      appliedFilters["value"] = filterInputState._id;
      appliedFilters["type"] = "_id";
    }
    setAppliedFilters([appliedFilters]);
    handleFilterModalClose();
  };
  const handleFilterChange = (key, val) => {
    setFilterInputState((prevState) => {
      return { ...prevState, [key]: val };
    });
  };

  const getInputLabel = (val, options, fromKey, toKey) => {
    const activeElement = options.find((item) => item[fromKey] === val);
    return activeElement ? activeElement[toKey] : val;
  };

  const getModal = () => {
    switch (modalState) {
      case "Filter":
        return (
          <NoFooterModal
            header={true}
            heading="Filter Banners"
            handleClose={handleFilterModalClose}
            id="DriverCampaignFilterModal"
            modalButtons={
              <BottomSectionModal className="flex items-center justify-between">
                <Button
                  data-testid="filterClearBtn"
                  onClick={handleClearFilters}
                  className="sushi-btn"
                >
                  Clear
                </Button>
                <Button
                  data-testid="filterSubmitButton"
                  className="sushi-btn"
                  onClick={handleFiltersApply}
                >
                  Apply
                </Button>
              </BottomSectionModal>
            }
          >
            <PaginatedReactDropdown
              options={filterOptions}
              labelKey="label"
              valueKey="value"
              data-testid="filterType"
              value={getInputLabel(
                filterInputState.type,
                filterOptions,
                "value",
                "label"
              )}
              handleChange={handleFilterChange}
              keyToChange="type"
              placeholder="Filter by"
              labelWidth="10%"
              id="filterType"
            />
            {filterInputState.type != "" ? (
              <Input
                value={
                  filterInputState.type == "name"
                    ? filterInputState.name
                    : filterInputState._id
                }
                data-testid="filterBy"
                onChange={(e) =>
                  handleFilterChange(
                    `${filterInputState.type == "name" ? "name" : "_id"}`,
                    e
                  )
                }
                id="sushi-input"
                label={`${
                  filterInputState.type == "name" ? "Banner Name" : "Banner ID"
                }`}
              />
            ) : (
              ""
            )}

            {formError.length > 0 ? (
              <div className={"error-state"}>{"*" + formError}</div>
            ) : (
              ""
            )}
          </NoFooterModal>
        );
    }
  };

  return (
    <div className="container">
      <FlexContainer align="flex-start">
        <Heading>&emsp;Banner Details</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.BANNER_VIEW]}>
            <FilterButton
              activeFilters={appliedFilters}
              handleClick={() => setModalState("Filter")}
            />
          </Permission>
          <Permission requiredPerms={[allActions.BANNER_CREATE]}>
            <Button
              onClick={() => history.push("/banner/create")}
              className="sushi-btn ml-12"
            >
              New Banner
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <Permission requiredPerms={[allActions.BANNER_VIEW]}>
        <BannersList driverBannerList={data?.banner_details} />
      </Permission>
      <Pagination
        page={page - 1}
        perPage={perPage}
        previousPage={data?.page_response?.previous_page ?? -1}
        nextPage={data?.page_response?.next_page ?? -1}
        onPageChange={handlePagination}
      />
      {modalState && getModal()}
    </div>
  );
};

export default BannerList;
